module.exports = __webpack_public_path__ + "img/start_green.svg.4d7fd8d8.svg";